<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Base64 Encode & Decode</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="encode()">Encode</v-btn>
            <v-btn color="primary" @click="decode()">Decode</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: ''
  }),
  methods: {
    encode() {
      this.result = btoa(this.text)
    },
    decode() {
      this.result = atob(this.text)
    }
  }
}
</script>

<style>
</style>